<template>

    <P5Canvas
        @setup="setup"
        @draw="draw"
    >

    </P5Canvas>
</template>

<script>
import P5Canvas from '@/components/P5Canvas.vue'

export default {
    name: "Epicircles",
    components: {
        P5Canvas,
    },
    props: {
        fourier: Array,
        size: Number,
        framerate: Number,
        smooth: Boolean
    },
    data: () => ({
        path: [],
        time: 0,
        sketch: null,
    }),
    watch: {
        framerate() {
            if (this.sketch)
                this.sketch.frameRate(this.framerate);
        },
        fourier() {
            this.path = [];
            this.time = 0;
        },
    },
    methods: {
        setup(sketch) {
            sketch.createCanvas(this.size,this.size);
            sketch.translate(sketch.width/2, sketch.height/2)
            sketch.frameRate(this.framerate)
            this.sketch = sketch;
        },
        epicycles(sketch, x, y, rotation, fourier) {
            for (let i = 0; i < fourier.length; i++) {
                let prevx = x;
                let prevy = y;
                let freq = i;
                let radius = fourier[i][0];
                let phase = fourier[i][1];
                x += radius * sketch.cos(freq * this.time + phase + rotation);
                y += radius * sketch.sin(freq * this.time + phase + rotation);

                sketch.strokeWeight(1)
                sketch.stroke(180);
                sketch.noFill();
                sketch.ellipse(prevx, prevy, radius * 2);
                sketch.stroke(180);
                sketch.line(prevx, prevy, x, y);
            }
            return sketch.createVector(x, y);
        },
        
        draw(sketch) {
            sketch.translate(sketch.width/2, sketch.height/2)
            sketch.background(255);

            let v = this.epicycles(sketch, 0, 0, 0, this.fourier);
            this.path.unshift(v);
            
            sketch.stroke(0)
            sketch.strokeWeight(2)
            sketch.noFill();
            sketch.beginShape();

            let N = this.path.length;
            let sf = N / 150.0;
            for (let i = 0; i < this.path.length; i++) {
                if (this.smooth) {
                    sketch.curveVertex(this.path[i].x, this.path[i].y);
                } else {
                    sketch.vertex(this.path[i].x, this.path[i].y);
                }
            }
            sketch.endShape();

            const dt = sketch.TWO_PI / this.fourier.length;
            this.time += dt;

            if (this.time > sketch.TWO_PI) {
                this.time = 0;
                this.path = [];
            }
        }   
    },

}
</script>

<style scoped>

.parent {
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
}

</style>